import React from "react";
import "./Vision.scss";
import { useIntl } from "react-intl";
import AOS from 'aos';
import 'aos/dist/aos.css'
import Quote from "./components/Quote";
import Value from "./components/Value";
import { API_BASE_URL } from "configs/AppConfig";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import { END_POINTS } from "constants/APIConstant";
import useSWR from "swr";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import ReactGA from "react-ga4";

function Vision() {

  const intl = useIntl();

  React.useEffect(() => {   
    AOS.init();
    AOS.refresh();
  }, [])

    
  ReactGA.initialize(END_POINTS.TRACKING_ID);
  
  React.useEffect(() => {
      // Send pageview with a custom path
      ReactGA.send({ hitType: "pageview", page: "/about/vision-mission", title: "About Vision Page" });
  }, []);
  

  // imgs
  const vision1 = process.env.PUBLIC_URL + "/image/Vision1.svg";
  const vision2 = process.env.PUBLIC_URL + "/image/Vision2.svg";
  const c1 = process.env.PUBLIC_URL + "/image/C1.svg";
  const c2 = process.env.PUBLIC_URL + "/image/C2.svg";
  const c3 = process.env.PUBLIC_URL + "/image/C3.svg";
  const c4 = process.env.PUBLIC_URL + "/image/C4.svg";
  const c5 = process.env.PUBLIC_URL + "/image/C5.svg";
  const c6 = process.env.PUBLIC_URL + "/image/C6.svg";
  const c7 = process.env.PUBLIC_URL + "/image/C7.svg";
  const c8 = process.env.PUBLIC_URL + "/image/C8.svg";
  const c9 = process.env.PUBLIC_URL + "/image/C9.svg";


  const parg = 'gchhgmmghcghcghcghcghcghcghcghcghcghcghcghcghgh';


  const values = [
    {
      title: 'الحرفية',
      desc: parg,
      imgTitle: c1
    },
    {
      title: 'العمل بروح الفريق',
      desc: parg,
      imgTitle: c6
    },
    {
      title: 'الدقة والموثوقية',
      desc: parg,
      imgTitle: c2
    },
    {
      title: 'الابتكار',
      desc: parg,
      imgTitle: c7
    },
    {
      title: 'الاستقلالية',
      desc: parg,
      imgTitle: c3
    },
    {
      title: 'سرية البيانات الفردية',
      desc: parg,
      imgTitle: c8
    },
    {
      title: 'المرونة والشفافية',
      desc: parg,
      imgTitle: c4
    },
    {
      title: 'تلبية احتياجات المستخدمين',
      desc: parg,
      imgTitle: c9
    },
    {
      title: 'التوقيت الملائم',
      desc: parg,
      imgTitle: c5
    },
  ]


  // const quotes = [
  //   {
  //     title: intl.formatMessage({ id: "vision"}),
  //     desc: `جهاز إحصائي متميز دولياً كفء وفعال وداعم للتنمية الاحتوائيةالمستدامة`,
  //     imgTitle: vision1,
  //   },
  //   {
  //     title: intl.formatMessage({ id: "the-message"}),
  //     desc: `دعم إنتاج ونشر وتحليل البيانات الإحصائية الرسمية عالية الجودة
  //       وفقاً لأفضل المعايير المهنية وأحدث التوصيات الدولية، بالتعاون مع
  //       كافة عناصر النظام الإحصائي، وإتاحتها لكافة المستخدمين على مختلف
  //       فئاتهم بعدالة وفى التوقيت المناسب وبالشكل الذى يتناسب مع
  //       احتياجاتهم ويضمن تسهيل حصولهم عليها، وذلك دون الإثقال على مقدمى
  //       البيانات، ومراعاة سرية البيانات الفردية`,
  //     imgTitle: vision2,
  //   }
  // ]


  // const animAos = [
  //   'fade-up-right',
  //   'fade-up-left',
  //   'fade-down-right',
  //   'fade-down-left',
  //   'flip-up',
  //   'flip-down',
  //   'flip-left',
  //   'flip-right',
  //   'slide-up',
  //   'slide-down',
  //   'slide-left',
  //   'slide-right',
  //   'fade-up-right',
  //   'fade-up-left',
  //   'fade-down-right',
  //   'fade-down-left',
  //   'flip-up',
  //   'flip-down',
  //   'flip-left',
  //   'flip-right',
  //   'slide-up',
  //   'slide-down',
  //   'slide-left',
  //   'slide-right'
  // ]


  const missionVision = useSWR({
    url: END_POINTS.MISSION_VISION,
  });

  const mainValues = useSWR({
    url: END_POINTS.MAIN_VALUE,
  });

  const [mission, setMission] = React.useState([]);
  const [vision, setVision] = React.useState([]);

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      setMission(missionVision?.data?.data.find(el => el.key === 'mission'))
      setVision(missionVision?.data?.data.find(el => el.key === 'vision'))
    }, 0);
    return () => {
      clearTimeout(timeOut)
    }
  }, [missionVision])


  return (
    <ContentLoading isLoading={missionVision.isLoading || mainValues.isLoading}>
      <div className="Vision">
        <div className="container">
          {/* vision */}
          <Quote
            title={intl.formatMessage({ id: "vision" })}
            desc={
              vision?.value !== null && vision?.value !== undefined
                ? vision?.value
                : intl.formatMessage({ id: "data-not-found" })
            }
            imgTitle={vision1}
            translation={
              vision?.elementTranslations
            }
            //animAos={animAos[0]}
          />

          {/* mission */}
          <Quote
            title={intl.formatMessage({ id: "mission" })}
            desc={
              mission?.value !== null && mission?.value !== undefined
                ? mission?.value
                : intl.formatMessage({ id: "data-not-found" })
            }
            imgTitle={vision2}
            translation={
              mission?.elementTranslations
            }
            //animAos={animAos[1]}
          />

          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div
                className="row gy-3 gx-0 gx-md-3 justify-content-md-start justify-content-center"
                // data-aos="fade-up"
                // data-aos-duration="800"
                // data-aos-easing="ease-in-sine"
              >
                <div className="col-12">
                  <div className="mb-4">
                    <h5
                      // data-aos="fade-right"
                      // data-aos-duration="800"
                      // data-aos-easing="ease-in-sine"
                      style={{ fontSize: "28px" }}
                    >
                      <b>{intl.formatMessage({ id: "main-values" })}</b>
                    </h5>
                  </div>
                </div>

                {mainValues?.data?.data && Object.keys(mainValues?.data?.data).length > 0 ? (
                  mainValues?.data?.data?.slice(0,10).map(({ title, description, imageUrl, mainValueTranslations }, i) => (
                    <Value
                      key={i}
                      title={title}
                      desc={description}
                      imgTitle={
                        imageUrl !== null && imageUrl !== undefined
                          ? `${API_BASE_URL}/${imageUrl}`
                          : values[i]?.imgTitle
                      }
                      translation={mainValueTranslations}
                      // animAos={animAos[i]}
                    />
                  ))
                ) : (
                  <DataNotFound />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default Vision;
